import {
    TextField,
    StandardTextFieldProps
} from '@material-ui/core';
import { FieldConfig, useField } from 'formik';

interface Props extends FieldConfig {
    label: string;
}

const InputField = ({ label, name, ...props }: Props | StandardTextFieldProps) => {
    const [field, meta] = useField(name);
    return (
        <div>
            <TextField
                fullWidth
                label={label}
                {...field}
                {...props}
                autoComplete="off"
                helperText={meta.touched && meta.error}
                error={Boolean(meta.touched && meta.error)}
                inputProps={{
                    autoComplete: 'new-password',
                    form: {
                        autoComplete: 'off',
                    },
                }}
            />
        </div>
    );
};

export default InputField;
